export default __webpack_public_path__ + "static/media/Darkslayer Hood.5f8d848d.jpg";